import { render, staticRenderFns } from "./HomeFooterCard.vue?vue&type=template&id=397946fe&scoped=true"
import script from "./HomeFooterCard.vue?vue&type=script&lang=js"
export * from "./HomeFooterCard.vue?vue&type=script&lang=js"
import style0 from "./HomeFooterCard.vue?vue&type=style&index=0&id=397946fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397946fe",
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg})
